module.exports = __webpack_public_path__ + "static/media/044.777600cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/044.jpg
// module id = 339
// module chunks = 0